<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    :width="width"
    :height="height"
  >
    <path d="M27.96 8.26828L16.96 2.24953C16.6661 2.08714 16.3358 2.00195 16 2.00195C15.6642 2.00195 15.3339 2.08714 15.04 2.24953L4.04 8.27078C3.72586 8.44267 3.46363 8.69573 3.28069 9.00357C3.09775 9.3114 3.00081 9.6627 3 10.0208V21.9758C3.00081 22.3339 3.09775 22.6852 3.28069 22.993C3.46363 23.3008 3.72586 23.5539 4.04 23.7258L15.04 29.747C15.3339 29.9094 15.6642 29.9946 16 29.9946C16.3358 29.9946 16.6661 29.9094 16.96 29.747L27.96 23.7258C28.2741 23.5539 28.5364 23.3008 28.7193 22.993C28.9023 22.6852 28.9992 22.3339 29 21.9758V10.022C28.9999 9.66331 28.9032 9.31123 28.7203 9.00268C28.5373 8.69413 28.2747 8.44047 27.96 8.26828ZM16 3.99953L26.0425 9.49953L22.3213 11.537L12.2775 6.03703L16 3.99953ZM16 14.9995L5.9575 9.49953L10.195 7.17953L20.2375 12.6795L16 14.9995ZM5 11.2495L15 16.722V27.4458L5 21.977V11.2495ZM27 21.972L17 27.4458V16.727L21 14.5383V18.9995C21 19.2648 21.1054 19.5191 21.2929 19.7066C21.4804 19.8942 21.7348 19.9995 22 19.9995C22.2652 19.9995 22.5196 19.8942 22.7071 19.7066C22.8946 19.5191 23 19.2648 23 18.9995V13.4433L27 11.2495V21.9708V21.972Z" />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 32,
    },
    height: {
      type: [Number, String],
      default: 32,
    },
  },
}
</script>

